import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TeacherStatsTable } from "../TeacherStatsTable";

export const StudentCareTab = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>นักเรียนในการดูแล</CardTitle>
        <CardDescription>
          ข้อมูลสถิติการสอนและจำนวนนักเรียนของครูแต่ละคน
          <br />
          <span className="text-xs text-muted-foreground">
            เลือกช่วงวันที่เพื่อดูเฉพาะนักเรียนที่สอนในช่วงเวลานั้น (ค่าเริ่มต้น: ทั้งหมด)
          </span>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <TeacherStatsTable />
      </CardContent>
    </Card>
  );
};
